export const pricingPlans = [
  {
    id: 'free',
    name: 'Free',
    description: 'Pour découvrir la plateforme',
    price: 0,
    period: 'Gratuit',
    popular: false,
    stripePriceId: 'price_1SHqAN87RdvVBQC5lVr2lEq2',
    features: [
      '2 QuikR Codes actifs',
      '10 tentatives de génération par mois',
      '5 QR codes actifs',
      'Designs basiques',
      'Téléchargement PNG',    
    ],
    limitations: [
      'Pas de statistiques avancées',
    ],
    buttonText: 'Commencer gratuitement',
    buttonStyle: 'secondary'
  },
  {
    id: 'basic',
    name: 'Basic',
    description: 'Pour un usage régulier et plus d’options',
    price: 12.99,
    period: 'mois',
    popular: false,
    stripePriceId: 'price_1SHqG387RdvVBQC5mqNbwkqn',
    features: [
      '+ 5 QuikR Codes actifs par mois',
      '60 tentatives de génération par mois',
      '+ 10 QR Codes actifs par mois',
      'Accès au tableau de bord analytique (7 jour)',
      'Support email standard',
    ],
    limitations: [
    ],
    buttonText: 'Essayer Basic',
    buttonStyle: 'secondary'
  },
  {
    id: 'clever',
    name: 'Clever',
    description: 'Idéal pour les créateurs et petites entreprises',
    price: 38.99,
    period: 'mois',
    popular: true,
    stripePriceId: 'price_1SHquT87RdvVBQC5bEUZOWVc',
    features: [
      '+ 20 QuikR Codes actifs par mois',
      '400 tentatives de génération par mois',
      '+ 100 QR Codes actifs par mois',
      'Accès au tableau de bord analytique (jusqu’à 120 jours)',
      'Export des statistiques et campagnes',
    ],
    limitations: [],
    buttonText: 'Choisir Clever',
    buttonStyle: 'primary'
  },
  {
    id: 'premium',
    name: 'Premium',
    description: 'Pour les équipes et entreprises exigeantes',
    price: 319.99,
    period: 'mois',
    popular: false,
    stripePriceId: 'price_1SHsVv87RdvVBQC5tH66KjNf',
    features: [
      '+ 200 QuikR Codes actifs par mois',
      '20000 tentatives de génération par mois',
      '+ 1000 QR Codes actifs par mois',
      'Tableau de bord analytique complet (1 an d’historique)',
      'Support prioritaire',
    ],
    limitations: [],
    buttonText: 'Passer à Premium',
    buttonStyle: 'secondary'
  },
  {
    id: 'custom',
    name: 'Custom',
    description: 'Solution sur mesure pour grandes entreprises',
    price: null,
    period: '',
    popular: false,
    stripePriceId: null,
    features: [
      'Fonctionnalités Premium incluses',
      'Tableau de bord analytique complet (2 an d’historique)',
      'Accès API',
      'SLA de disponibilité garanti',
      'Support dédié 24/7',
      'QuikR Code GS1'
    ],
    limitations: [],
    buttonText: 'Contacter les ventes',
    buttonStyle: 'secondary'
  }
];

export const pricingConfig = {
  title: 'Choisissez votre plan',
  subtitle: 'Des solutions flexibles adaptées à vos besoins',
  showMonthlyYearly: true,
  yearlyDiscount: 20,
  currency: '€',
  features: {
    highlight: [
      'QuikR Codes',
      'Tableau de bord analytique',
      'Pages de destination personnalisables'
    ]
  }
};
